import { Lock } from '@phosphor-icons/react';

import type { ConsoleRole } from '@/lib/auth/types';

interface ForbiddenPageProps {
    allowed: readonly ConsoleRole[];
    actual: ConsoleRole;
}

export function ForbiddenPage({ allowed, actual }: ForbiddenPageProps) {
    return (
        <div className="container flex min-h-[60vh] flex-col items-center justify-center gap-3 py-12 text-center">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground">
                <Lock weight="regular" className="h-5 w-5" aria-hidden />
            </span>
            <p className="font-display text-lg font-semibold text-foreground">Access restricted</p>
            <p className="max-w-md text-sm text-muted-foreground">
                This area is reserved for {formatRoles(allowed)}. Your current role is{' '}
                <span className="font-medium text-foreground">{actual}</span>. Ask a partner admin
                if you need access.
            </p>
        </div>
    );
}

function formatRoles(roles: readonly ConsoleRole[]): string {
    if (roles.length === 0) return 'admins only';
    if (roles.length === 1) return roles[0]!;
    return `${roles.slice(0, -1).join(', ')} or ${roles[roles.length - 1]!}`;
}
